import { Eshop } from '@/types/eshop';
import { useGetAffiliateEshopsListBySlugQuery } from './generated';
import { sanityLanguage } from '@/constants/language';

// Always sync with https://gitlab.com/mallpay/frontend/cms/-/blob/main/schemas/affiliateEshopsList.ts
type Slug =
	| 'default'
	| 'css-program'
	| 'card'
	| 'pay-in-three'
	| 'products'
	| 'deferred-payment'
	| 'revolving-loan'
	| 'homepage'
	| 'xmas'
	| 'springOffer';

export type EshopsList = { front: Eshop; back: Eshop }[];

async function getEshopsListBySlug(slug: Slug): Promise<Eshop[]> {
	const fetchAffiliateEshopsLists = useGetAffiliateEshopsListBySlugQuery.fetcher({
		slug,
		i18nLang: sanityLanguage,
	});

	const affiliateEshopsLists = await fetchAffiliateEshopsLists();

	if (
		!affiliateEshopsLists?.allAffiliateEshopsList ||
		!affiliateEshopsLists.allAffiliateEshopsList.length ||
		!affiliateEshopsLists.allAffiliateEshopsList[0].eshops
	) {
		throw new Error('No affiliate panels found and there are expected to be some.');
	}

	return affiliateEshopsLists.allAffiliateEshopsList[0].eshops.map((eshop) => ({
		eshopLink: eshop?.link || '',
		imagePath: eshop?.image?.asset?.url || '',
		imageAlt: eshop?.imageAlt || '',
	}));
}

function transformEshopsToFrontAndBack(eshops: Eshop[]): EshopsList {
	const front = eshops.slice(0, Math.ceil(eshops.length / 2));
	const back = eshops.slice(Math.ceil(eshops.length / 2), eshops.length);

	return front.map((eshop, index) => ({
		front: eshop,
		back: back[index] || eshop,
	}));
}

export async function getAffiliateEshopsList(slug: Slug): Promise<EshopsList> {
	const data = await getEshopsListBySlug(slug);

	return transformEshopsToFrontAndBack(data);
}
